// Module
var code = `{{#rows}}
<div class="{{attrRowClass}}" data-event-id="{{attrEventId}}">
  <div class="flex min-w-0 items-center">
    <img
      src="{{attrImageSrc}}"
      alt="{{attrImageAlt}}"
      class="mr-4 rounded-full"
      width="28"
      height="28"
    />
    <div class="min-w-0">
      <p class="truncate text-sm font-medium md:text-base">{{msg}}</p>
      <p class="text-xs text-gray-500">{{time}}</p>
    </div>
  </div>
  <span class="{{attrPillClass}}">{{pillLabel}}</span>
</div>
{{/rows}}
`;
// Exports
module.exports = code;